import * as s from './Separator.module.scss'

const Separator: React.FC = () => <div className={s.root} />

export default Separator
